import React, { useState } from 'react';
import { FiMessageSquare, FiDatabase, FiUpload, FiLink, FiChevronLeft, FiChevronRight } from 'react-icons/fi';

const NAV_ITEMS = [
  { id: 'chat', label: 'SOP Chat', icon: FiMessageSquare },
  { id: 'library', label: 'Document Library', icon: FiDatabase },
  { id: 'sharepoint', label: 'SharePoint Sync', icon: FiLink },
  { id: 'upload', label: 'Upload Documents', icon: FiUpload },
];

export default function SOPSidebar({ activePage, onNavigate }) {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div style={{
      width: collapsed ? 60 : 240,
      minHeight: '100vh',
      background: '#0B1437',
      borderRight: '1px solid #1E2A4A',
      display: 'flex',
      flexDirection: 'column',
      transition: 'width 0.2s ease',
      overflow: 'hidden',
    }}>
      {/* Header */}
      <div style={{
        padding: collapsed ? '20px 10px' : '20px 16px',
        borderBottom: '1px solid #1E2A4A',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}>
        {!collapsed && (
          <div>
            <div style={{ color: '#fff', fontWeight: 700, fontSize: 16 }}>Strike AI</div>
            <div style={{ color: '#64748B', fontSize: 11, marginTop: 2 }}>SOP Document Manager</div>
          </div>
        )}
        <button
          onClick={() => setCollapsed(!collapsed)}
          style={{
            background: 'none', border: 'none', color: '#64748B',
            cursor: 'pointer', padding: 4, display: 'flex',
          }}
          title={collapsed ? 'Expand' : 'Collapse'}
        >
          {collapsed ? <FiChevronRight size={18} /> : <FiChevronLeft size={18} />}
        </button>
      </div>

      {/* Nav items */}
      <div style={{ padding: '12px 8px', flex: 1 }}>
        {NAV_ITEMS.map(item => {
          const Icon = item.icon;
          const isActive = activePage === item.id;
          return (
            <button
              key={item.id}
              onClick={() => onNavigate(item.id)}
              style={{
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                gap: 12,
                padding: collapsed ? '10px 14px' : '10px 12px',
                marginBottom: 4,
                background: isActive ? '#1E3A5F' : 'transparent',
                border: 'none',
                borderRadius: 8,
                color: isActive ? '#3B82F6' : '#94A3B8',
                cursor: 'pointer',
                fontSize: 14,
                fontWeight: isActive ? 600 : 400,
                transition: 'all 0.15s ease',
                justifyContent: collapsed ? 'center' : 'flex-start',
              }}
              title={collapsed ? item.label : undefined}
            >
              <Icon size={18} />
              {!collapsed && <span>{item.label}</span>}
            </button>
          );
        })}
      </div>

      {/* Footer */}
      {!collapsed && (
        <div style={{
          padding: '16px',
          borderTop: '1px solid #1E2A4A',
          color: '#475569',
          fontSize: 11,
        }}>
          RAG Pipeline v1.0
        </div>
      )}
    </div>
  );
}
